import { OnboardingCarePhases, OnboardingCarePhasesPhaseOne } from '@/pages/OnboardingCarePhases';

export function GenworthOnboardingCarePhasesPhaseOne(_props: ClientIdProps) {
  return (
    <OnboardingCarePhases
      slidePage={OnboardingCarePhasesPhaseOne}
      title="How a typical care timeline progresses"
    />
  );
}
